module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/19b1c1d2f4b6173cc8d4c718c0611248.png";